import { useSearchParams } from 'react-router-dom';
import AdminLayout from '../../components/layout/AdminLayout';
import SupervisorLayout from '../../components/layout/SupervisorLayout';
import { useAuth } from '../../contexts/AuthContext';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { MessageSquare, CreditCard } from 'lucide-react';
import { EventFeedbackContent } from './FeedbackDashboardPage';
import { PublicFeedbackContent } from './AdminPublicFeedbackPage';
import StaffQRCardManager from '../../components/StaffQRCardManager';

const VALID_TABS = ['events', 'staff', 'cards'];

export default function AdminFeedbackHubPage() {
  const { user } = useAuth();
  const Layout = user?.role === 'supervisor' ? SupervisorLayout : AdminLayout;
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get('tab');
  const tab = VALID_TABS.includes(tabParam) ? tabParam : 'events';

  return (
    <Layout>
      <div className="p-4 sm:p-6 space-y-6 min-h-screen" data-testid="feedback-hub">
        <div className="border-b border-border pb-4">
          <h1 className="text-2xl font-barlow tracking-widest flex items-center gap-3">
            <MessageSquare className="w-6 h-6 text-primary" />
            FEEDBACK
          </h1>
          <p className="text-sm text-muted-foreground mt-1">Events, staff feedback and QR cards — all in one place.</p>
        </div>

        <Tabs value={tab} onValueChange={(v) => setSearchParams(v === 'events' ? {} : { tab: v })}>
          <TabsList className="rounded-sm">
            <TabsTrigger value="events" data-testid="feedback-tab-events" className="rounded-sm">Events</TabsTrigger>
            <TabsTrigger value="staff" data-testid="feedback-tab-staff" className="rounded-sm">Staff</TabsTrigger>
            <TabsTrigger value="cards" data-testid="feedback-tab-cards" className="rounded-sm">QR Cards</TabsTrigger>
          </TabsList>
          <TabsContent value="events" className="mt-4">
            <EventFeedbackContent />
          </TabsContent>
          <TabsContent value="staff" className="mt-4">
            <PublicFeedbackContent />
          </TabsContent>
          <TabsContent value="cards" className="mt-4">
            <Card className="bg-card border-border rounded-sm" data-testid="staff-qr-cards-page">
              <CardHeader className="border-b border-border">
                <CardTitle className="font-barlow tracking-wider uppercase flex items-center gap-2">
                  <CreditCard className="w-5 h-5 text-primary" />
                  Staff QR Cards
                </CardTitle>
                <p className="text-sm text-muted-foreground mt-2">
                  Print reusable QR cards once, then assign them to staff. Each card has its
                  own unique URL. Reassigning a card keeps existing feedback linked to the
                  previous owner.
                </p>
              </CardHeader>
              <CardContent className="p-4 sm:p-6">
                <StaffQRCardManager />
              </CardContent>
            </Card>
          </TabsContent>
        </Tabs>
      </div>
    </Layout>
  );
}
